enum Currency {
	USD = '$',
	EUR = '\u20ac',
	GBP = '\u00a3',
	CHF = 'CHF',
	LEK = 'LEK',
	BGN = 'BGN',
	CZK = 'CZK',
	ILS = 'ILS',
	RSD = 'RSD',
	AUD = 'AUD',
	SGD = 'SGD',
	TRY = 'TRY'
}

export default Currency;